<template>
  <div>
    <v-layout align-center justify-center fill-height class="mx-2 mb-4">
      <v-flex fill-height class="mx-2 d-flex flex-row">
        <m-form-text
          type="text"
          class="filtre"
          labelPosition="top"
          :name="$Utils.randomstring('search-product')"
          label="Rech. textuelle"
          v-model="searchProduct"
          @input="searchGo"
        ></m-form-text>

        <m-form-combobox
          v-model="searchFamily"
          label="Famille"
          class="filtre"
          labelPosition="top"
          :name="$Utils.randomstring('search-family')"
          :store-url="$config.server_url + '/api/1.0/families/combobox/1'"
          :store-params="{ catalog: catalog, subfamily: 0 }"
          item-text="fa_name_fr"
          item-value="fa_id"
          @input="searchGo"
        ></m-form-combobox>

        <m-form-combobox
          v-model="searchSubFamily"
          label="Sous-famille"
          class="filtre"
          labelPosition="top"
          :name="$Utils.randomstring('search-subfamily')"
          :store-url="$config.server_url + '/api/1.0/families/combobox/2'"
          :store-params="
            searchFamily
              ? { family: searchFamily.fa_id, catalog: catalog }
              : { family: 0, catalog: catalog }
          "
          item-text="fa_name_fr"
          item-value="fa_id"
          @input="searchGo"
        ></m-form-combobox>

        <m-form-select
          class="filtre"
          :name="$Utils.randomstring('search-status')"
          :items="$store.state.items_search_status"
          v-model="searchStatus"
          label="Status"
          labelPosition="top"
          @input="searchGo"
        ></m-form-select>

        <m-form-select
          class="filtre"
          v-model="searchPromo"
          label="Promo"
          labelPosition="top"
          :name="$Utils.randomstring('search-promo')"
          :items="$store.state.items_search_promo"
          @input="searchGo"
        ></m-form-select>

        <m-form-combobox
          v-model="searchMdd"
          label="MDD"
          class="filtre"
          labelPosition="top"
          :name="$Utils.randomstring('search-mdd')"
          :store-url="$config.server_url + '/api/1.0/mdd/combobox'"
          :store-params="{}"
          item-text="text"
          item-value="value"
          @input="searchGo"
        ></m-form-combobox>

        <div
          class="ml-4 withpointer icon-cross"
          @click.stop="deleteFiltre('searchPromo')"
        >
          <icon class name="times"></icon>
        </div>
      </v-flex>
      <!-- <v-flex>
        <a href>plus d'options</a>
      </v-flex>-->
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "catalog-search",
  components: {},
  props: {
    catalog: Number
  },
  data() {
    return {
      searchProduct: "",
      searchFamily: null,
      searchSubFamily: null,
      searchStatus: null,
      searchPromo: null,
      tsSearch: null,
      searchMdd: null
    };
  },
  watch: {
    async searchSubFamily(val) {
      if (!val) return;
      let params = { subfamily: val.fa_id_parent, catalog: this.catalog };
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/families/families",
        { params }
      );
      // console.log("response.data.data", response.data.data);
      this.searchFamily = response.data.data[0];
      this.searchGo();
    },
    searchFamily(val) {
      if (
        this.searchSubFamily &&
        val.fa_id != this.searchSubFamily.fa_id_parent
      ) {
        this.searchSubFamily = null;
      }
      this.searchGo();
    },
    searchProduct(val) {
      this.searchGo();
    },
    searchPromo(val) {
      this.searchGo();
    },
    searchStatus(val) {
      this.searchGo();
    }
  },
  async mounted() {},
  destroyed() {},
  methods: {
    searchGo() {
      if (this.tsSearch) clearTimeout(this.tsSearch);
      this.tsSearch = setTimeout(() => {
        // console.log("this.searchMdd", this.searchMdd, this.searchStatus);
        let searchMdd = this.searchMdd ? this.searchMdd.text : "";
        this.$emit(
          "searchGo",
          this.searchProduct,
          this.searchFamily,
          this.searchSubFamily,
          this.searchStatus,
          this.searchPromo,
          searchMdd
        );
      }, 500);
    },
    deleteFiltre() {
      this.searchProduct = "";
      this.searchFamily = null;
      this.searchSubFamily = null;
      this.searchStatus = null;
      this.searchPromo = null;
      this.searchMdd = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.icon-cross {
  align-self: flex-end;
}
.filtre {
  width: 88%;
  margin-left: 15px;
  label {
    font-size: 15px;
  }
}
</style>
